export default "__VITE_ASSET__CSPJGjfu__"